<empty-layout *ngIf="layout === 'empty'"></empty-layout>
<classic-layout *ngIf="layout === 'classic'"></classic-layout>
